<template>
  <div style="transition: 0.4s; z-index:2204;" class="flex-1 bg-white rounded-xl space-y-6 p-6 tip-block" :class="[nowStep == 5 ? 'w-5/12 step_index4' : 'w-1/3 step_index'+nowStep ]">
    <p v-html="content"  :class="[nowStep == 2 ? 'w-4/6' : '' ]"></p>
    <button
      v-if="nowStep === 5"
      class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
      @click="nextTos()"
    >
      {{startText}}
    </button>
    <YouTube
      v-if="nowStep === 5"
      :src="defaultPlay"
      width="750"
      height="455"
      @ready="onReady"
      ref="youtube"
      :vars="vars"
    />
    <!-- <div v-if="nowStep === 2 || nowStep == 31 || nowStep == 5 || nowStep == 6 " class="tip-footer"> -->
    <div class="tip-footer">
      <!-- <button
        :style="{ opacity: nowStep === 1 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep !== 1"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button> -->
      <button
        class="hover:bg-gray-400 focus:outline-none rounded-xl px-4 py-1 mr-2 text-white transition duration-500 ease-in-out border-gray-500 border-2 bg-gray-500"
        @click="endLinkTeaching()"
      >
        結束教學
      </button>
      <button
        v-if="nowStep === 2"
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
        @click="next()"
      >
        {{iknow}}
      </button>
      <button
        v-if="nowStep != 2 && nowStep != 31 && nowStep != 6 && nowStep != 7"
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
        @click="next()"
      >
        {{nextText}}
      </button>
      <!-- <span v-if="time > 0">{{time}}</span> -->
      <button
        v-if="nowStep == 31 || nowStep === 6"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="closeTips()"
      >
        {{finishText}}
      </button>
      <button
        v-if="nowStep === 7"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="stageCloseTips()"
      >
        {{finishText}}
      </button>
    </div>
  </div>
  <section v-if="nowStep === 2" class="box_04">
    <div class="item_04"></div>
    <div class="item_04"></div>
  </section>
  <div v-if="nowStep === 2" class="w-24 h-24 border-red-400 rounded-3xl border-8" style="transition: all 0.4s ease 0s; z-index: 2205; position: absolute; bottom: 7px; right: 7px;"></div>
</template>

<script>
import * as contentData from '@/components/Mask/LinkAccount.json';

export default {
  name: 'LinkAccountMask',
  props: {
    nowStep: {
      type: Number,
      default: -1
    },
    selectLang: {
      type: String
    },
    topCode: {
      type: String
    },
    viewDatalist: {
      type: String
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      startText: '開始操作',
      nextText: '下一步',
      finishText: '好的',
      closeTipsText: '跳過教學',
      iknow: '我知道了',
      code: null,
      defaultPlay: 'https://youtu.be/PiuVfLjbY9s',
      vars: {
        rel: 0,
        start: 0,
      },
      timer: null,
      time: 10,
    }
  },
  created() {
    // console.log('this.countdown');
    // this.countdown();
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'zh-CN'){
          this.startText = '开始操作';
          this.nextText = '下一步';
          this.finishText = '好的';
          this.closeTipsText = '跳过教学';
          this.iknow = '我知道了';

          message = data[0].content_zh_CN;
        }
        if(this.selectLang == 'en-US'){
          this.startText = 'start operation';
          this.nextText = 'next';
          this.finishText = 'finish';
          this.closeTipsText = 'skip teaching';
          this.iknow = 'I know';

          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  watch:{
    'topCode':function(v){
      let status = v.split('_');

      console.log('topCode status');
      console.log(status);

      if(status[0] == 'true'){
        this.code = status[1]
        // this.tosWindows(status[1]);
        this.$emit('nextStep');
      }
    },
    'nowStep':function(v){
      console.log('link account mask nowStep');
      console.log(v);
      if(v === 2){
        // this.countdown();
      }
    }
  },
  mounted() {
    // this.timer = setInterval(this.countdown, 1000);
  },
  methods: {
    nextTos() {
      // this.$emit('nextStep');
      this.tosWindows();
      // this.nowStep = this.nowStep + 1;
    },
    closeTips() {
      console.log('closeTips');
      console.log(this.nowStep);
      if(this.nowStep == 31){
        this.$emit('closeTips', 'notSmooth');
      } else {
        this.$emit('closeTips');
      }
    },
    stageCloseTips() {
      console.log('stageCloseTips');
      this.$emit('closeTips', 'stageClose');
    },
    tosWindows(){
      var iHeight = 600;
      var iWidth = 1000;
      //获得窗口的垂直位置
      var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
      //获得窗口的水平位置
      var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
      var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,titlebar=no';

      var url = 'https://business.facebook.com/customaudiences/app/tos/?'+this.code;
      // var url = 'https://www.facebook.com';

      console.log('this.code');
      console.log(this.code);

      var ch_window = window.open(url, '', windowStyle);

      // var timer = setInterval(function() {
      //   console.log('success ch_window:', ch_window);
      //   if(ch_window.closed) {
      //     console.log('已關閉');
      //     clearInterval(timer);
      //     // window.location.reload();
      //   }
      // }, 1000);
    },
    onReady() {
      console.log('youtube');
      // this.$refs.youtube.playVideo()
      // this.$refs.youtube.pauseVideo()

      this.$refs.youtube.seekTo(0, true);
    },
    next() {
      console.log('nowStep');
      console.log(this.nowStep);

      // if(this.nowStep == 2){
      //   // window.open('http://m.me/1055506187980947');
      //   window.open('http://m.me/1055506187980947','messageTalk','width=800,height=600');
      // }

      if(this.nowStep == 4){
        this.$emit('nextStep', 4);
      } else {
        this.$emit('nextStep');
      }

      // this.nowStep = this.nowStep + 1;
    },
    countdown() {
      this.time --;
      console.log('this.time --');
      console.log(this.time);
      if(this.time == 0){
        console.log('clearInterval');
        clearInterval(this.timer)
      }
    },
    endLinkTeaching(){
      console.log('linkaccount endLinkTeaching');
      this.$emit('closeForTeaching', false);
    }
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    clearInterval(this.timer);
  }
};

</script>

<style lang="scss">

.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 100;
}
/* .step_index1 {
  position: absolute;
  top: 38vh;
  left: 50vw;
} */

.step_index2 {
  position: absolute;
  bottom: 0;
  right: 0;
}

.step_index3 {
  position: absolute;
  top: 17vh;
  left: 30vw;
}

.step_index31 {
  position: absolute;
  top: 17vh;
  left: 30vw;
}

.step_index4 {
  position: absolute;
  top: 0;
  left: 30vw;
}

.step_index5 {
  position: absolute;
  top: 5%;
  left: 25%;
}

.step_index6 {
  position: absolute;
  top: 38vh;
  left: 56vw;
}

.step_index7 {
  position: absolute;
  top: 32vh;
  left: 10vw;
}

/*.step_index6 {
  position: absolute;
  top: 38vh;
  left: 34vw;
}*/

.tip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
<style>
  .box_04 {
    z-index: 2205;
    position: absolute;
    bottom: 15px;
    right: 135px;
    padding: 0;
    /*position: relative;*/
    height: 80px;
  }
  .box_04 .item_04 {
    position: absolute;
    left: 40%;
    width: 10px;
    height: 40px;
    background: rgba(248,113,113,var(--tw-border-opacity));
  }
  .box_04 .item_04:nth-child(1) {
    top: 0;
    transform: skewX(30deg);
  }
  .box_04 .item_04:nth-child(2) {
    bottom: 0;
    transform: skewX(-30deg);
  }
</style>